import { createContext } from 'react';
import { type Auth, type User } from 'firebase/auth';
import { type RoleContext, type ResourceKey, type PermissionAction } from '../lib/roles';
import { type RoleScope } from '../services/auth/roleResolver';
import type { DataScopeV1 } from '../types/effectiveScope';

interface PermissionCheckOptions {
  audit?: boolean;
  reason?: string;
  resourceId?: string;
}

export interface AuthContextType {
  authUser: User | null;
  loading: boolean;
  auth: Auth | null;
  userRole: string | null;
  roleContext: RoleContext | null;
  roleScope: RoleScope | null;
  /** Effective scope derived in Auth (single writer); matches Role breakdown table + mergeSupervisorLofScope. */
  dataScope: DataScopeV1 | null;
  isAdmin: boolean;
  canAccess: (resource: ResourceKey, action: PermissionAction, options?: PermissionCheckOptions) => boolean;
  forceRefresh: () => Promise<void>;
  firestoreUser: Record<string, unknown> | null;
}

const defaultCanAccess = () => false;

export const AuthContext = createContext<AuthContextType>({
  authUser: null,
  loading: true,
  auth: null,
  userRole: null,
  roleContext: null,
  roleScope: null,
  dataScope: null,
  isAdmin: false,
  canAccess: defaultCanAccess,
  forceRefresh: async () => {},
  firestoreUser: null,
});
